import React from "react";
import { Form, Input, Modal } from "antd";
import Button from "../common/button";
import Map from "../Map/Map";
import Dropdown from "./dropdown";
import { UsaStates } from "usa-states";
const CustomOkButton = ({ onClick }) => (
  <Button
    title="Save"
    onClick={onClick}
    className="bg-lightBlue !text-black w-full !focus:text-white sm:w-19 h-5.4 !hover:shadow-none"
  />
);

const CustomCancelButton = ({ onClick }) => (
  <Button
    title="Cancel"
    onClick={onClick}
    className="bg-lightBlue hover:bg-lightBlue focus:bg-primaryBlue !focus:text-white w-full sm:w-19 h-5.4 !text-black"
  />
);
const LocationMapModal = ({
  onCancel,
  onOk,
  onLocationChange,
  defaultValue,
}) => {
  const [form] = Form.useForm();
  const usStates = new UsaStates();

  const handleOk = () => {
    form
      .validateFields()
      .then((values) => {
        // If validation is successful, trigger onOk
        onOk(values);
        // setIsModalOpen(false); // Close modal if validation passes
      })
      .catch((error) => {
        // Handle validation errors
        console.log("Validation Failed:", error);
      });
  };
  return (
    <div>
      <Modal
        open={true}
        footer={null}
        maskClosable={true}
        closeIcon={null}
        className="2xl:top-[10%] top-2"
        width="900px"
        onCancel={onCancel}
      >
        <h3>Choose your location</h3>
        <Map
          onLocationChange={onLocationChange}
          defaultValue={defaultValue?.businessLocation?.coordinates}
        />
        <h3>Business Address</h3>
        <Form form={form} layout="vertical">
          <Form.Item
            name="address"
            initialValue={defaultValue?.businessAddress}
            rules={[
              {
                required: true,
                message: "Please enter a business address",
              },
            ]}
          >
            <Input
              type="text"
              placeholder="Business Address"
              defaultValue={defaultValue?.businessAddress}
              className="w-full border rounded py-1.5"
            />
          </Form.Item>
          <div className="flex gap-2">
            <Form.Item
              name="city"
              className="w-full"
              initialValue={defaultValue?.city}
              rules={[
                {
                  required: true,
                  message: "Please enter city",
                },
              ]}
            >
              <Input
                type="text"
                placeholder="City"
                defaultValue={defaultValue?.city}
                className="w-full border rounded py-1.5"
              />
            </Form.Item>
            <Form.Item
              className="w-full rounded-md"
              name="state"
              initialValue={defaultValue?.state}
              rules={[{ required: true, message: "Please enter your state" }]}
            >
              <Dropdown
                placeholder="State"
                data={usStates?.states}
                defaultValue={defaultValue?.state}
              />
            </Form.Item>
          </div>
        </Form>
        <div className="flex space-x-2 sm:space-x-2 flex-row justify-end mt-2">
          <CustomCancelButton onClick={onCancel} />
          <CustomOkButton onClick={handleOk} />
        </div>
      </Modal>
    </div>
  );
};
export default LocationMapModal;
